module.exports = "<div class=\"{classes}\">\n    {#list cells as cell}\n    <span\n        class=\"{this.getCellCls(cell)}\"\n        on-click=\"{this.onClick(cell, $event)}\"\n        on-mouseenter=\"{this.onMouseMove(cell)}\"\n\n    >\n        <em class=\"{prefixCls}-month__cell-em {prefixCls}__cell-em\">{ cell.text }</em>\n    </span>\n    {/list}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/form/KLDate/base/month.table/index.html
// module id = 485
// module chunks = 0